import { render, staticRenderFns } from "./RedeemView.vue?vue&type=template&id=16fbcc00&scoped=true"
import script from "./RedeemView.vue?vue&type=script&lang=js"
export * from "./RedeemView.vue?vue&type=script&lang=js"
import style0 from "./RedeemView.vue?vue&type=style&index=0&id=16fbcc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbcc00",
  null
  
)

export default component.exports